export default {
  halted: 'Halted',
  hour: 'Hour'
}
